export default "__VITE_ASSET__CNVBLTub__"